export const MODAL_WIDTH = "530px";
export const ITEMS_TO_DISPLAY = 3;
export const RIDES_ONE_PASSENGER_NUMBER = 1;
